import React from 'react'
import { TLogo } from './styles'

type TeamLogoProps = {
  logo: string
}

export const TeamLogo: React.FC<React.PropsWithChildren<TeamLogoProps>> = ({ logo }) => {
  return <TLogo src={logo} alt="Team Logo" />
}
